module.exports = __webpack_public_path__ + "img/icon-delete-3.a0e9eb29.svg";